/**
 * How far back "activity" reaches, in days — the Activity Log's window, and now the Overview home's
 * feed window too.
 *
 * It lives in its own module because `lib/activity.ts` reaches the app's dependency graph (React Query,
 * the api client, the duplexer → common-lib) and `lib/home3-feed.ts` deliberately does not: a unit test
 * that imports the feed model must not drag that graph in, or it passes locally against `dist/` and
 * fails in CI against `src/` (orion-web/CLAUDE.md → Tests). Same reason `lib/brief-date-key.ts` and
 * `lib/recipient-error.ts` exist.
 *
 * **One number, so the two screens cannot disagree about what "activity" means.** The Overview feed and
 * the Activity Log it links to are the same rows over the same span; if this moves, both move together.
 */
export const ACTIVITY_WINDOW_DAYS = 30;

export const ACTIVITY_WINDOW_MS = ACTIVITY_WINDOW_DAYS * 24 * 60 * 60 * 1000;
